import importerStore from '@shared/importer/importer-store';
import { PlayerService } from '@modules/player/player-service';
import playerImporterFields from '@modules/player/player-importer-fields';
import { i18n } from '@shared/i18n';

export default importerStore(
  PlayerService.import,
  playerImporterFields,
  i18n('entities.player.importer.fileName'),
  i18n('entities.player.importer.hint'),
);
